import React, { useState } from 'react'
import { Link,  } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import tw, { styled } from 'twin.macro'
import { SubMenu } from './submenu'
import { StyledLink } from './style'
import { HamburgerMenu } from './hamburger-menu'
import { colorGold } from '@styles/color'


const MenuRow = styled.div`
  margin: 0 auto;
  height: 120px;
`

const Menu = styled.div`
  ${tw`flex sm:flex-row lg:items-center items-end flex-col justify-center`}
  width: 100%;
`

const DropdownContent = styled('div')`
  display: none;
  position: absolute;
  top: 55px;
  left: 0;
  width: 100vw;
  height: 315px;
  z-index: 1;
  animation-fill-mode: forwards;
  transition-duration: 500ms;
  transform: translateY(300px);
  transition-property: opacity;
  opacity: 0.6;
  &:hover {
    display: block;
    opacity: 1;
    transform: translateY(0);
  }
`

const Dropdown = styled('div')`
  display: inline-block;
  box-sizing: border-box;
  max-width: 100%;
  &:hover {
    ${DropdownContent} {
      display: block;
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const Logo = styled(StaticImage)`
  max-height: 82px;
  max-width: 216px;

  position: absolute;
  top: 12px;
`

export const MenuContainer = styled('div')`
  ${tw`flex items-center md:justify-between mb-6 lg:mb-0 lg:mr-6 flex-row sm:visible invisible`}
`

export const StyledLinkL = styled(StyledLink)`
  ${tw`text-base m-5`}
  letter-spacing: 1px;
`;


export const StyledLinkXL = styled(StyledLink)`
  ${tw`text-lg`}
  letter-spacing: 1px;
`;

export const StyledCaptionXL = styled('span')`
${tw`text-gray-800 text-lg font-semibold antialiased tracking-wide m-3 p-3 transition-colors duration-300 ease-in-out cursor-pointer`}
  &:hover {
    color: ${colorGold};
  }
  color: rgb(35, 35, 35);
  letter-spacing: 1px;
  font-weight: 700;
  text-transform: uppercase;
`;

const LogoContainer = styled('div')`
  height: 100%;
  opacity: 0.93;
  cursor: pointer;
  overflow: hidden;
  svg {
    margin-top: -44px;
  }
`
export const HamburgerContainer = styled('div')`
${tw`sm:justify-center justify-between p-3 pb-0`}

  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  HamburgerMenu {
    display: block;
    @media (min-width: 640px) {
      display: none;
    }
  }
`;

const LogoSvg = ()=> {
  return (
    <svg
       width="100%"
       height="100"
       xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient
          id="gradient"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="100%"
          spreadMethod="pad"
          cx="1371.8474"
          cy="107"
          fx="1371.8474"
          fy="107"
          r="5"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.37901484,0,0,0.37901484,-301.66087,33.694995)">
          <stop
            offset="0%"
            stopColor="#03a9f4"
            stopOpacity="1"/>
          <stop
            offset="100%"
            stopColor="#03a9f4"
            stopOpacity="0"/>
        </radialGradient>
      </defs>
      <path
        d="M 232.62323,73.417823 H 26.609913 v 1.729415 H 231.79115 c 10.35931,0 12.43708,1.059408 12.43524,-2.004241 -2.5e-4,-0.407615 -0.0744,-0.780595 -0.15675,-1.033678 -0.10898,-0.335454 -0.28217,-0.535592 -0.80755,-1.064435 -3.80343,-3.76729 -4.05614,-13.143782 -1.56383,-14.989944 0.96575,-1.100462 4.03891,-0.332321 7.33081,0.892007 4.77857,1.777253 12.51993,3.464578 12.44313,2.843957 -4.72413,-1.735758 -8.38312,-3.56724 -10.59615,-5.005931 -5.08975,-2.771189 -12.48693,-5.134295 -14.13217,-0.364066 -2.41628,7.468178 3.82178,12.400882 2.79873,16.251271 -0.74946,1.525352 -2.73908,2.557369 -6.91938,2.745648 z M 261.3888,50.423939 c 5.97578,0 8.09723,2.333745 8.09723,7.427647 0,5.942888 -4.35786,11.282113 -7.61049,14.898157 -5.86233,6.508879 9.93069,17.899317 4.40875,24.219529 -2.19364,2.484067 -4.19809,3.396318 -6.80777,1.698354 -1.96672,-1.2892 -3.35349,-3.520567 -4.37467,-7.922707 -0.94553,-4.087698 -3.03841,-5.912975 -6.25323,-8.648587 -0.75643,-0.628876 -1.51286,-1.666524 0.15128,-1.697967 4.34947,-0.09433 8.66111,9.779033 10.09832,12.766201 3.36611,7.011984 6.75756,3.969961 5.62292,-1.721379 -0.15128,-1.06909 -2.10552,-5.605039 -2.78631,-6.894235 -3.13918,-5.817112 -6.58041,-8.310505 -1.35311,-14.151121 0.34061,-0.323628 1.61789,-1.952188 1.90967,-2.349975 2.20298,-3.003336 3.05274,-7.804588 3.13079,-9.635637 0.9404,-8.473362 -8.42031,-2.684025 -12.89349,-3.806086 -0.17298,-0.04339 -0.33865,-0.220009 -0.49613,-0.284911 -1.23678,-1.969052 5.67139,-3.871087 9.15624,-3.897283 z m -12.0485,36.011643 c -0.68079,0.282995 -1.66414,1.257753 -2.53404,2.672729 -1.70196,2.672726 -2.76096,3.427378 -3.36611,3.11294 -1.09682,-0.565987 -0.83207,-4.527916 -0.15128,-7.011979 0.30257,-1.069091 1.02118,-5.691336 0.26475,-7.294976 -0.52951,-1.069091 -1.62632,-0.314438 -2.08019,0.314444 -0.49167,0.691762 -0.60514,1.66652 -0.68078,2.798501 -0.15128,3.238716 -1.02117,6.320213 -1.059,9.716148 -0.0756,8.552731 8.2829,6.634651 10.28743,-3.018611 0.11346,-0.408767 0.3404,-1.72941 -0.68078,-1.289196 z"
        fill="#000000"
        opacity="1"
        strokeWidth="0.379015"/>
      <circle
        cx="218.28969"
        cy="74.24958"
        r="1.8950741"
        fill="url(#gradient)"
        strokeWidth="0.379015"/>
      <text
        x="31.193224"
        y="93.07975"
        fill="#000000"
        fontFamily="sans-serif"
        fontSize="25.561px"
        transform="scale(1.3361526,0.74841754)">
       <tspan
          x="31.193224"
          y="93.07975"
          fontSize="25.561px"
          fontFamily="'Yu Gothic'"
          fill="#000000"
          fillOpacity="1"
          strokeWidth="0.639024">
          MEDIROOT
       </tspan>
      </text>
    </svg>
    );
}


export const  MenuComponent = () => {
  return (
      <MenuRow className="menu-container">
        <Menu>
          <HamburgerContainer>
              <Link to="/mm">
                <HamburgerMenu/>
              </Link>
            <LogoContainer>
              <Link to="/">
                <LogoSvg/>
              </Link>
            </LogoContainer>
          </HamburgerContainer>

          <MenuContainer>
            <Dropdown>
              <StyledLinkL to="/oferta/stomatologia-zachowawcza" >Oferta</StyledLinkL>
              <DropdownContent>
                <SubMenu/>
              </DropdownContent>
            </Dropdown>

            <StyledLinkL to="/zespol" >Zespół</StyledLinkL>
            <StyledLinkL to="/cennik" >Cennik</StyledLinkL>
            <StyledLinkL to="/galeria" >Galeria</StyledLinkL>
            <StyledLinkL to="/kontakt" >Kontakt</StyledLinkL>

          </MenuContainer>
        </Menu>
      </MenuRow>
  )
}

